<template>
  <div class="f2g-wind-container">
    <ModalJumpNotes v-if="showModalWithNotes" :dataJumpNotes="dataJumpResponseValue.dataJump.disclaimerSubtitle"
            :disclaimerTitle="locale === 'el_GR' ? 'Λεπτομέρειες' : 'Details'" @close-modal="setCloseModalWithNotes" />

    <div class="banner-colorful lightblue-banner" v-if="newTopupInfo.hasNewTopUpTariff == false">
      <svg class="svg-banner-colorful hidden-xs hiddem-sm" width="80px" height="80px" viewBox="0 0 80 80" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <desc>Created with Sketch.</desc>
        <g id="Icon/tip" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M40,16 C31.1816,16 24,23.181061 24,31.9995121 C24,35.4962855 25.14688,38.7211471 27.05,41.349627 C27.0718752,41.3840011 27.0781248,41.4152498 27.1,41.4496239 C28.84064,44.2151396 30.4,46.1526005 30.4,50.399751 C30.4,51.2372454 31.162496,51.9997022 32,51.9997022 L48,51.9997022 C48.83752,51.9997022 49.6,51.2372294 49.6,50.399751 C49.6,46.1530005 51.15936,44.2155396 52.9,41.4496239 C52.9218752,41.4152498 52.9281248,41.3840011 52.95,41.349627 C54.85312,38.7215471 56,35.4966854 56,31.9995121 C56,23.181381 48.81872,16 40,16 Z M40,19.1999024 C47.08752,19.1999024 52.8,24.9122082 52.8,31.9995121 C52.8,34.8338257 51.86248,37.4211868 50.3,39.5492819 C50.2812496,39.5805305 50.2656248,39.6149047 50.25,39.6492788 C48.7844,41.9929673 46.98752,44.6678458 46.57496,48.7993998 L33.42456,48.7993998 C33.012064,44.6682458 31.2152,41.9933673 29.74952,39.6492788 C29.7338952,39.6149047 29.7182704,39.5805305 29.69952,39.5492819 C28.13704,37.4211868 27.19952,34.8338257 27.19952,31.9995121 C27.19952,24.9122082 32.912,19.1999024 39.99952,19.1999024 L40,19.1999024 Z M44.62496,25.574748 C44.321832,25.6184971 44.031208,25.7497427 43.8,25.9497366 L35.8,32.3495414 C35.353128,32.7214021 35.134376,33.3495109 35.256248,33.9182136 C35.37812,34.4869482 35.837496,34.9713015 36.400008,35.1244168 L40.024968,36.0994271 L36.474968,39.6493188 C35.859344,40.233677 35.84372,41.3305475 36.4405928,41.9336491 C37.0374648,42.5367588 38.1343528,42.5336308 38.7249928,41.9242742 L44.2749928,36.3744435 C45.0624968,35.5807157 44.6312408,33.9869963 43.5499928,33.699485 L40.2999928,32.849511 L45.7999928,28.4496451 C46.3718648,28.0309059 46.6031128,27.209043 46.3374968,26.552823 C46.0687448,25.896595 45.3250168,25.471576 44.6250168,25.5746928 L44.62496,25.574748 Z M32.64976,54.398669 C31.81224,54.4392926 31.08416,55.2361635 31.1248,56.0736579 C31.1623,56.9111524 31.96232,57.6392102 32.79984,57.5985714 L47.19984,57.5985714 C48.0436,57.6110711 48.82168,56.8454664 48.82168,55.9986202 C48.82168,55.1517741 48.043552,54.3861894 47.19984,54.398669 L32.64944,54.398669 L32.64976,54.398669 Z M35.84976,60.7984739 C35.01224,60.8390974 34.28416,61.6359683 34.3248,62.4734628 C34.3623,63.3109572 35.16232,64.039015 35.99984,63.9983763 L43.99984,63.9983763 C44.8436,64.0108759 45.62168,63.2452712 45.62168,62.3984251 C45.62168,61.5515789 44.843552,60.7859942 43.99984,60.7984739 L35.84944,60.7984739 L35.84976,60.7984739 Z"
            id="Shape" fill="#060700" fill-rule="nonzero" />
        </g>
      </svg>
      <div>
        <div class="bold-title-banner">{{ newTopupInfo.extraInfo.ribonTitle }}</div>
        <div v-html="newTopupInfo.extraInfo.ribonSubtitle" class="main-text-banner hidden-xs hidden-sm"></div>
        <div v-html="newTopupInfo.extraInfo.ribonSubtitle" class="main-text-banner hidden-lg hidden-md"></div>
      </div>
      <div class="btn-banner-logwin">
        <div class="container-button-banner">
          <div class="container-button black-btn" v-on:click="redirectNewTopUp()">
            {{ newTopupInfo.extraInfo.ribonButtonLabel }}
          </div>
        </div>
      </div>
    </div>

    <!-- Data jump banner -->
    <div class="banner-colorful data-jump-banner" v-if="dataJumpResponse.isDataJumpEligible">
      <img class="svg-banner-colorful hidden-xs hiddem-sm" src="/ext_files/prepaid/f2g/images/data-jump.png"
        style="width: 65px;">
      <div class="titles-container" style="margin-left: 15px;">
        <div class="bold-title-banner">{{ dataJumpResponse.dataJump.ribonTitle ? dataJumpResponse.dataJump.ribonTitle :
          'Data jump' }}</div>
        <div
          v-html="dataJumpResponse.dataJump.ribonSubtitle ? dataJumpResponse.dataJump.ribonSubtitle : 'Ενεργοποίησε το datajump για να διπλασιάσεις τα MB σου.'"
          class="main-text-banner hidden-xs hidden-sm"></div>
        <div
          v-html="dataJumpResponse.dataJump.ribonSubtitle ? dataJumpResponse.dataJump.ribonSubtitle : 'Ενεργοποίησε το datajump για να διπλασιάσεις τα MB σου.'"
          class="main-text-banner hidden-lg hidden-md"></div>
      </div>
      <div class="btn-banner-logwin">
        <div class="tooltip">
          <svg class="margin-left-5 " width="40px" height="40px" viewBox="0 0 20 20" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Icon/Bundle/rollover_tip</title>
            <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Icon/Bundle/rollover_tip">
                <circle id="Oval" fill="#E2E7EB" cx="10" cy="10" r="8"></circle>
                <path
                  d="M9.63970393,12.2539072 C9.29495948,12.2539072 9.04018204,12.0039097 8.99519854,11.6656331 L8.88293341,10.3976459 C8.82321969,10.0007698 9.06286743,9.70624279 9.46772916,9.66210323 C10.8765465,9.52968456 11.6560636,9.00038987 11.6560636,8.07381917 L11.6560636,8.04413146 C11.6560636,7.22069972 11.0111607,6.64684548 9.9323413,6.64684548 C9.13775161,6.64684548 8.49325641,6.92614268 7.89371413,7.45581736 C7.74362984,7.57339619 7.54857223,7.6616753 7.33877829,7.6616753 C6.87460437,7.6616753 6.5,7.29370899 6.5,6.85270341 C6.5,6.63200563 6.58996803,6.39684799 6.79976095,6.22028976 C7.59435064,5.48552713 8.5986935,5 9.97734519,5 C12.0756922,5 13.5,6.14729049 13.5,7.98587205 L13.5,8.01555975 C13.5,9.86864116 12.1357178,10.7069328 10.472123,10.9866299 L10.3741926,11.6663131 C10.3140815,11.9897499 10.0744317,12.2545872 9.7292898,12.2545872 L9.63971922,12.2541962 L9.63970393,12.2539072 Z M10.4884185,14.1632884 C10.4884185,14.6250037 10.1066498,15 9.63650393,15 C9.16516566,15 8.78379441,14.6253937 8.78379441,14.1632884 C8.78379441,13.7011827 9.16516566,13.3269665 9.63650393,13.3269665 C10.1070473,13.3273575 10.4884185,13.7015727 10.4884185,14.1632884 Z"
                  id="Combined-Shape" fill="#87888B"></path>
              </g>
            </g>
          </svg>
          <div class="tooltiptext data-jump-tooltip">
            <div v-if="dataJumpNotesAreRight" class="small-title-bundle">
              <ul class="remarks-ul">
                <li v-for="el in dataJumpContentStrings">
                  {{ el }}
                </li>
                <li v-if="hasMoreDataJumpNotes">
                  {{ locale === 'el_GR' ? "Μάθε περισσότερα" : 'Learn more' }}
                  <span class="learn-more" @click="setShowModalWithNotes">
                    {{ locale === 'el_GR' ?
                      'εδώ' : 'here' }}
                  </span>
                </li>
              </ul>
            </div>
            <div v-else class="small-title-bundle" v-html="dataJumpResponseValue.dataJump.disclaimerSubtitle"></div>
          </div>
        </div>
        <div class="container-button-banner">
          <div class="container-button black-btn" v-on:click="redirectTo(urlForDataJump)">
            {{ dataJumpResponse.dataJump.ribonButtonLabel ? dataJumpResponse.dataJump.ribonButtonLabel : 'Πάτα εδώ' }}
          </div>
        </div>
      </div>
    </div>

    <div class="etopup-tempate">
      <div class="title-bundles-details">{{ content["myf2g.topup.title"] }}</div>
      <div class="mini-title-offers" style="margin-top:10px;"><template v-if="!isRevenueBooster">{{ personalizedMessage
      }}</template>
      </div>
      <div id="enable-pop-up-msg" class="paypal-element" style="display:none;">
        {{ content["myf2g.topup.message1"] }}
      </div>
      <div class="row row-f2g">
        <div class="col-md-8 col-xs-12 col-sm-12">
          <img src="/ext_files/prepaid/f2g/images/step_1@2x.png" class="img-step-etopup hidden-sm hidden-xs" />
          <div class="hidden-lg hidden-md steps-title-xs">{{ content["myf2g.topup.titleStep1"] }}</div>
          <div class="bold-title-etop">{{ content["myf2g.topup.message2"] }}</div>

          <div class="hidden-md hidden-lg amounts-xs-box">
            <div class="check-box-amount" v-for="amountObject in topUpAmounts" v-bind:key="amountObject.amount"
              v-bind:class="{ 'active-check-box-amount': amountObject.amount === selectedAmount }"
              v-on:click="getSelectedAmount(amountObject.amount)">
              <div class="ampount-xs">{{ amountObject.amount }}</div>
              <svg class="svg-box-amounts" width="32px" height="32px" viewBox="0 0 32 32" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icon/Bundle/bonus</title>
                <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Icon/Bundle/bonus" fill="#8D02F4">
                    <path
                      d="M24.9278222,32 C27.2041956,32 29.0554667,30.1486222 29.0554667,27.8723556 L29.0554667,11.8766222 C29.0554667,9.60024889 27.2040889,7.74897778 24.9278222,7.74897778 L20.0236444,7.74897778 L22.1514311,5.86147556 C22.8806044,5.21425778 23.2819911,4.34481778 23.2819911,3.41148444 C23.2819911,2.47815111 22.8806044,1.60871111 22.1514311,0.961493333 C20.7056,-0.320462222 18.3512533,-0.320462222 16.9055644,0.961493333 L16.1555556,1.62677333 L15.4069333,0.96288 C13.9611022,-0.319075556 11.6067556,-0.319075556 10.1610667,0.96288 C9.43189333,1.60871111 9.03050667,2.47953778 9.03050667,3.41287111 C9.03050667,4.34620444 9.43189333,5.21564444 10.1610667,5.86286222 L12.2888533,7.75036444 L7.38325333,7.74897564 C5.10688,7.74897564 3.25560889,9.60035342 3.25560889,11.8766201 L3.25560889,27.8723534 C3.25560889,30.1487268 5.10837333,32 7.38325333,32 L24.9278222,32 Z M24.9278222,9.29713529 C26.3500444,9.29713529 27.5083733,10.4541867 27.5083733,11.8777956 L27.5069842,27.8721067 C27.5069842,29.2943289 26.350042,30.4526578 24.9264331,30.4526578 L19.7666108,30.4512686 L19.7666108,9.29713529 L24.9278222,9.29713529 Z M11.1873778,4.70417778 C10.7943111,4.35556622 10.5776711,3.89724444 10.5776711,3.41251556 C10.5776711,2.92778667 10.7943396,2.46947556 11.1873778,2.12085333 C12.0526578,1.35420444 13.5151644,1.35420444 14.3790578,2.12085333 L16.1554489,3.69585778 L17.93184,2.12085333 C18.79712,1.35420444 20.2596267,1.35420444 21.12352,2.12085333 C21.5165867,2.46946489 21.7332267,2.92778667 21.7332267,3.41251556 C21.7332267,3.89724444 21.5165582,4.35555556 21.12352,4.70417778 L17.9596444,7.51111111 C17.8568676,7.60139022 17.742976,7.679168 17.622144,7.75000178 L14.6901973,7.75000178 C14.5693653,7.68055822 14.4554738,7.60278044 14.3526969,7.51111111 L11.1873778,4.70417778 Z M4.80408889,11.8764444 C4.80408889,10.4542222 5.96103111,9.29589333 7.38464,9.29589333 L12.5444622,9.29589333 L12.5444622,30.4514489 L7.38321778,30.4514489 C5.96099556,30.4514489 4.80266667,29.2945067 4.80266667,27.8708978 L4.80408889,11.8764444 Z"
                      id="Shape"></path>
                  </g>
                </g>
              </svg>
              <div class="text-amount-etopup-table" v-if="locale === 'en_US'"
                v-html="amountObject.bonusResponsiveMessageEN">
              </div>
              <div class="text-amount-etopup-table" v-else v-html="amountObject.bonusResponsiveMessage">
              </div>
            </div>

            <div class="check-box-amount" v-on:click="getSelectedAmount('Other')">
              <div>
                <div class="bold-other-amount mb-view extra-margin-bottom">{{ content["myf2g.topup.message4"] }}</div>
                <div class="medium-other-amount mb-view">{{ content["myf2g.topup.message5"] }}{{ minTopUp }}
                  {{ content["myf2g.topup.message6"] }}{{ maxTopUp }}</div>
              </div>
              <div class="col-md-2 padding-0">
                <input type="text" name="fname" class="input-etopup mb-view-bg" v-model="userAmount"
                  v-on:keyup="fixUserAmount(userAmount)" value placeholder="€" />
              </div>
            </div>

          </div>

          <div class="hidden-sm hidden-xs">
            <div v-for="(amountObject, index) in topUpAmounts" v-bind:key="amountObject.amount"
              v-bind:class="['table-etopup-amount', 'row', 'row-f2g', { 'border-radius-top': index == 0 }, 'hidden-sm', 'hidden-xs']"
              v-on:click="getSelectedAmount(amountObject.amount)">
              <div class="col-md-2 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input type="radio" :id="amountObject.amount" name="amount" :value="amountObject.amount" />
                    <label :for="amountObject.amount">{{ amountObject.amount }}€</label>
                  </div>
                </div>
              </div>
              <div class="col-md-10 padding-0">
                <div class="text-amount-etopup-table" v-if="locale === 'en_US'" v-html="amountObject.bonusMessageEN">
                </div>
                <div class="text-amount-etopup-table" v-else v-html="amountObject.bonusMessage">
                </div>
              </div>
            </div>

            <div class="table-etopup-amount row row-f2g hidden-sm hidden-xs" v-on:click="getSelectedAmount('Other')">
              <div class="col-md-10 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input type="radio" id="Other" name="amount" value />
                    <label for="ritemb"></label>
                  </div>
                  <div>
                    <div class="bold-other-amount">{{ content["myf2g.topup.message4"] }}</div>
                    <div class="medium-other-amount">{{ content["myf2g.topup.message5"] }}{{ minTopUp }}
                      {{ content["myf2g.topup.message6"] }}{{ maxTopUp }}</div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 padding-0">
                <input type="text" name="fname" class="input-etopup" v-model="userAmount"
                  v-on:keyup="fixUserAmount(userAmount)" value placeholder="€" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xs-12 col-sm-12 right-side-items">
          <!-- Case 10300 -->
          <template v-if="isRevenueBooster">
            <img src="/ext_files/prepaid/f2g/images/step_2@2x.png" class="img-step-etopup hidden-sm hidden-xs" />
            <div class="hidden-lg hidden-md steps-title-xs">{{ content["myf2g.topup.titleStep2"] }}</div>
            <div class="bold-title-etop">{{ content["myf2g.topup.message.step.10300.title"] }}</div>
            <div class="table-etopup-amount row row-f2g revenue">
              <div class="col-md-12 padding-0">
                {{ revenueBoosterMessage }}
              </div>
            </div>

          </template>
          <!-- Case 10300 then steps will be 3   -->
          <template v-if="isRevenueBooster">
            <img src="/ext_files/prepaid/f2g/images/step_3@2x.png" class="img-step-etopup hidden-sm hidden-xs" />
            <div class="hidden-lg hidden-md steps-title-xs">{{ content["myf2g.topup.titleStep3"] }}</div>
          </template>
          <temlate v-else>
            <img src="/ext_files/prepaid/f2g/images/step_2@2x.png" class="img-step-etopup hidden-sm hidden-xs" />
            <div class="hidden-lg hidden-md steps-title-xs">{{ content["myf2g.topup.titleStep2"] }}</div>
          </temlate>

          <div class="bold-title-etop">{{ content["myf2g.topup.message3"] }}</div>

          <div class="hidden-md hidden-lg amounts-xs-box payment-xs-box">

            <div class="check-box-amount" v-on:click="choseMethod('Credit')"
              v-bind:class="{ 'active-check-box-amount': paymentOption === 'Credit' }">
              <div class="xs-title-payment">{{ content["myf2g.topup.label1"] }}</div>
              <img src="/ext_files/prepaid/f2g/images/payment-card.svg">
            </div>
          </div>

          <div class="container-blue-btn btn-payment-etopup hidden-lg hidden-md">
            <div class="overlay-button-container"
              v-bind:class="{ 'disabled-button': !(amountIsEligible && hasChoosenMethod) }">
              <input type="submit" :value="content['myf2g.topup.button'] + ' ' + selectedAmount + '€'"
                class="container-button" v-bind:class="{ 'blue-btn': amountIsEligible && hasChoosenMethod }"
                v-on:click="pay()" />
            </div>
          </div>

          <div class="hidden-xs hidden-sm">
            <div class="table-etopup-amount row row-f2g border-radius-top" v-on:click="choseMethod('Credit')">
              <div class="col-md-12 padding-0">
                <div class="amount-etopup-table">
                  <div class="radio-items-f2g">
                    <input type="radio" id="Credit" name="payment" value="ropt2" />
                    <label for="ritemb">{{ content["myf2g.topup.label1"] }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-etopup-amount row row-f2g">
              <div class="col-md-2 padding-0"></div>
              <div class="col-md-10 padding-0">
                <img src="/ext_files/prepaid/f2g/images/payment-card.svg">
              </div>
            </div>

            <div class="table-etopup-amount row row-f2g">
              <div class="col-md-12 padding-0">
                <div id="buttonContainer"
                  v-bind:class="['overlay-button-container', { 'disabled-button': !(amountIsEligible && hasChoosenMethod) }]">
                  <input id="myf2g-topup-step1" type="submit"
                    :value="content['myf2g.topup.button'] + ' ' + selectedAmount + '€'"
                    v-bind:class="['container-button', { 'blue-btn': amountIsEligible && hasChoosenMethod }]"
                    v-on:click="pay()" />
                </div>
              </div>
            </div>
          </div>
          <div class="top-up-terms" v-html="content['f2g.topup.terms']"></div>
        </div>
      </div>


    </div>
  </div>
</template>



<script>
// import $ from "jquery";
import axios from "axios";
import ModalJumpNotes from "../components/ModalJumpNotes.vue";

export default {
  name: "PaymentOptions",
  components: {
    ModalJumpNotes
  },
  data: function () {
    return {
      dataJumpNotesAreRight: false,
      dataJumpContentStrings: [],
      showModalWithNotes: false,
      hasMoreDataJumpNotes: false,
      selectedAmount: 0,
      userAmount: "",
      amountIsEligible: false,
      hasChoosenMethod: false,
      getPaypalTokenResponse: '',
      content: '',
      paymentOption: '',
      modalInitialized: false,
      dataJumpResponseValue: {},
    };
  },
  created() {
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let configWCS = {
      sessionKey: "wcs_topup",
      axiosConfig: {
        method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gtopup',
          locale: self.locale
        }
      }
    }

    this.fetchDataFromWCS(configWCS)
      .then(response => {
        console.log(JSON.stringify(response))
        self.content = response
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        console.log("finally");
      });

    //this.getUserProfileAndTariffs();

    this.$nextTick(function () {
      this.numbersOnly();
    });
    this.$nextTick(function () {
      this.choseMethod('Credit');
    });
  },
  updated() {
    $(".check-box-amount").each(function () {
      if (!$(this).hasClass("slick-slide")) {
        $(this).addClass("slick-slide");
      }
    })
    if ($(".open-as-modal") !== null && this.modalInitialized === false) {
      //initialize terms modal
      $(".open-as-modal").each(function (index, value) {
        $(this).animatedModal({
          animatedIn: 'bounceIn',
          animatedOut: 'bounceOut',
          animationDuration: '.6s',
          color: '#FFFFFF',
          // Callbacks
          beforeOpen: function () {
            console.log("The animation was called");
          },
          afterOpen: function () {
            console.log("The animation is completed");
          },
          beforeClose: function () {
            console.log("The animation was called");
          },
          afterClose: function () {
            console.log("The animation is completed");
          }
        });
      });
      this.modalInitialized = true;

    }
  },
  beforeMount() {
    this.retrieveNewTopUpInfo();
    this.callDataJumpAvailability();
  },
  computed: {
    urlForDataJump() {
      return `/${this.getLocale === 'el' ? 'gr' : 'en'}/f2g/upiresies/online-ananeosi-hronou-omilias/online-ananeosi-hronou-omilias-meso-myf2g-/?dataJumpFlow=true`;
    },
    dataJumpResponse() {
      return this.dataJumpResponseValue;
    },
    getDataJumpFlow() {
      return this.$store.getters.getIsDataJumpFlow;
    },
    getUserProfileAndTariffsObject() {
      return this.$store.state.userProfileAndTariffsObject;
    },
    personalizedMessage() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.getUserProfileAndTariffsObject.personalizedMessage;
      }
    },
    topUpAmounts() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.topUpAmountsExtended;
      } else {
        return [];
      }
    },
    isRevenueBooster() {
      var revenueBooster = false;
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK" && this.$store.state.userProfileAndTariffsObject.topupAmountMessages) {
        revenueBooster = true;
      }
      return revenueBooster;
    },
    revenueBoosterMessage() {
      var revenueBoosterMessage = "";
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK" && this.$store.state.userProfileAndTariffsObject.topupAmountMessages) {
        //Default message
        revenueBoosterMessage = this.$store.state.userProfileAndTariffsObject.topupAmountMessages.defaultMesage;

        //Try to find the corresponding message in the rangeMessages structure
        if (this.$store.state.userProfileAndTariffsObject.topupAmountMessages.rangeMessages) {
          var self = this;
          this.$store.state.userProfileAndTariffsObject.topupAmountMessages.rangeMessages.forEach(function (range) {
            //between range
            if (self.selectedAmount >= range.minAmount && self.selectedAmount <= range.maxAmount) {
              revenueBoosterMessage = range.topupMsg;
            }
          });
        }
      }

      return revenueBoosterMessage;
    },
    minTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.minTopUp;
      } else {
        return 0;
      }
    },
    maxTopUp() {
      if (this.$store.state.userProfileAndTariffsObject.errorCode === "OK") {
        return this.$store.state.userProfileAndTariffsObject
          .prepaidTariffTopUpInfo.resultJsonObject.prepaidTariff.maxTopUp;
      } else {
        return 0;
      }
    },
    token() {
      return this.$store.state.token;
    },
    cardAndRecurringInfoObject() {
      return this.$store.state.cardAndRecurringInfoObject;
    },
    getLocale() {
      var locale;
      if ($("body").data("locale") == "el_GR") {
        locale = "el";
      } else {
        locale = "en";
      }
      return locale;
    },
    email() {
      return this.$store.state.email;
    },
    locale() {
      return this.$store.state.locale;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    newTopupInfo() {
      return this.$store.state.newTopupInfoResponse;
    },
    showWarningModal() {
      return this.$store.state.showWarningModal;
    },
  },
  methods: {
    setShowModalWithNotes() {
      this.showModalWithNotes = true;
      console.log('Learn more clicked');
    },
    setCloseModalWithNotes() {
      this.showModalWithNotes = false;
      console.log('Close clicked');
    },
    redirectTo(path) {
      console.log("Redirecting to: " + path);
      window.location.href = path;
    },
    callDataJumpAvailability() {
      /* 
        callGetSiebelCampaigns method is called in order to fetch the available campaigns for the user
      */

      //Build request
      let req = this.addCaller({});

      //Build the axios configuration for the service call
      let config = {
        method: "post",
        url: "/apiv2/bundles/dataJumpAvailability/",
        data: req
      };

      //scope
      let self = this;

      //Call service and handle response
      axios(config)
        .then(response => {
          self.dataJumpResponseValue = response.data;
          this.handleDataJumpNotes();
        })
        .catch(error => {
          console.log(error);
          /* Handle the error case */
        })
        .finally(() => {

        });
    },
    handleDataJumpNotes() {
      let currentDataJumpNotes = this.dataJumpResponseValue.dataJump.disclaimerSubtitle;
      console.log("currentDataJumpNotes", currentDataJumpNotes);
      // check if the dataJumpNotes is of proper structure: <ul> and <li> elements
      if (currentDataJumpNotes && currentDataJumpNotes.includes('<ul') && currentDataJumpNotes.includes('<li')) {
        this.dataJumpNotesAreRight = true;
      }

      //create an array of string with all the content of <li> elements
      if (this.dataJumpNotesAreRight) {
        let dataJumpNotesArray = currentDataJumpNotes.split('<li>');
        dataJumpNotesArray.shift();
        dataJumpNotesArray = dataJumpNotesArray.map((note) => note.split('</li>')[0]);
        console.log("dataJumpNotesArray", dataJumpNotesArray);

        // Limit to first three items and set a flag if there are more items
        this.dataJumpContentStrings = dataJumpNotesArray.slice(0, 3);
        this.hasMoreDataJumpNotes = dataJumpNotesArray.length > 3;
      }
    },
    redirectNewTopUp() {
      //code to redirect
      var url;

      if (this.locale == "en_US") {
        url = "/en/myf2g/#/?toTopUp=true";
      } else {
        url = "/gr/myf2g/#/?toTopUp=true";
      }
      window.location.href = url;
    },
    retrieveNewTopUpInfo() {

      //Build request
      let req = this.addCaller({});

      //Build the axios configuration for the service call
      let config = {
        method: "post",
        url: "/apiv2/bundles/retrieveNewTopUpInfo/",
        data: req
      };

      config.headers = {
        "oidc-telephonenumber": btoa(this.loginInfo.msisdn)
      }


      //scope
      let self = this;


      config.data = self.addCaller(config.data);

      //Call service and handle response
      axios(config)
        .then(response => {
          if (response.data.errorLevel == 0) {
            self.$store.commit("setNewTopupInfoResponse", response.data);
          } else {
            console.log(response);
            /* Handle the error case */
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            let config = {
              method: "get",
              url: "/sites/Satellite/",
              params: {
                c: "ContentInstanceAsset",
                cid: "1526319536600",
                d: "Touch",
                locale: "el_GR",
                pagename: "myF2GWrapperEntry",
                performLogout: true
              },
            };
            axios(config).then(response => {

              console.log(response);

              sessionStorage.clear();

              if (document.getElementsByTagName("BODY")[0].getAttribute("data-locale") == "en_US") {
                window.location.href = "/en/f2g/";
              } else {
                window.location.href = "/gr/f2g/";
              }


            }).catch(error => {
              console.error("Logout failed with error: " + error);
            })
          }

          console.log("STATUS: " + error.response.status);

          reject(error.response);
        })
        .finally(() => {
          // self.$store.commit("decrementShowLoader");
          // keepAliveModule.main();
        });
    },
    addCaller(data) {
      //console.log('data: '+JSON.stringify(data))

      let updatedData = data;

      let callerUsername = (this.$store.state.loginInfo.username === "") ? "anonymous" : this.$store.state.loginInfo.username;

      updatedData.caller = {
        callingSystem: "myF2Gweb",
        salesCode: "",
        username: callerUsername,
        data: "",
        locale: this.$store.state.locale,
        channel: "F2G"
      }

      //console.log('updatedData: '+JSON.stringify(updatedData))

      return updatedData;

    },
    getUserProfileAndTariffs() {
      var token = this.token;
      var self = this;
      axios({
        method: "post",
        url: "/mpay/getUserProfileAndTariffs",
        data: {
          token: token,
          tokenFLag: "1",
          locale: this.getLocale
        }
      })
        .then(response => {
          if (response.data.errorCode === "OK") {
            console.log(
              "getUserProfileAndTariffs response: " +
              JSON.stringify(response.data)
            );
            sessionStorage.setItem(
              "getUserProfileAndTariffs_" + "F2G_" + self.token,
              JSON.stringify(response.data)
            );
            this.$store.commit("setUserProfileAndTariffs", response.data);
            //case of warning modal
            console.log("Warning modal: " + response.data.forcePersonalData);
            if (response.data.forcePersonalData) {
              this.$store.commit("showWarningModal", true);
              this.$store.commit("forcePersonalDataMessage", response.data.forcePersonalDataMessage);
            }
            // BANK DEEP LINKING AND DATA JUMP FLOW
            var urlParams = new URLSearchParams(window.location.search);
            var bankDeepLinking = urlParams.get('bankDeepLinking');
            if (bankDeepLinking && !this.showWarningModal) {
              var amount = urlParams.get('amount');
              self.selectedAmount = amount;
              this.$store.commit("setAmount", amount);
              self.amountIsEligible = true;
              self.pay();
            } else if (self.getDataJumpFlow) {
              self.selectedAmount = response.data.dataJump.dataJumpAmount; //this has to come dynamically
              this.$store.commit("setAmount", response.data.dataJump.dataJumpAmount); //this has to come dynamically
              self.amountIsEligible = true;
              self.pay();
            } else {
              this.$store.commit("hideLoader");
            }

          } else {
            console.log(
              "getUserProfileAndTariffs response: " +
              JSON.stringify(response.data)
            );
            if (
              response.data.fault != undefined &&
              response.data.fault.faultCode == 19
            ) {
              var faultDescription = response.data.fault.faultDescription;
              this.$store.commit("setFaultDescription", faultDescription);
            } else if (response.data.fault != undefined && response.data.fault.faultCode == 25) {
              var forcePersonalDataErrorMessage = response.data.forcePersonalDataErrorMessage;
              var faultDescription = response.data.fault.faultDescription;
              this.$store.commit("setFaultDescription", faultDescription);
              this.$store.commit("forcePersonalDataErrorMessage", forcePersonalDataErrorMessage);
            }

            this.$store.commit("showErrorComponent", true);
            this.$store.commit("hideLoader");
          }
        })
        .catch(error => {
          console.log(
            "getUserProfileAndTariffs responded with error: " + error
          );
          this.$store.commit("showErrorComponent", true);
          this.$store.commit("hideLoader");
        })
        .finally(() => {
          $('.amounts-xs-box').slick({
            infinite: false,
            variableWidth: true,
            arrows: false,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 680,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 430,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
          });
        });
    },
    getSelectedAmount(amount) {
      //If datajumpflow is true clear vuex from datajump values
      console.log("clearing data jump values if dataJumpFlow is true", this.getDataJumpFlow);
      if (this.getDataJumpFlow) {
        this.$store.commit("setIsDataJumpFlow", false);
        this.$store.commit("setIsDataJumpSession", false);
      }
      this.userAmount = "";
      if (amount == "Other") {
        this.selectedAmount = 0;
        this.amountIsEligible = false;
      } else {
        this.selectedAmount = amount;
        this.amountIsEligible = true;
        this.$store.commit("setAmount", this.selectedAmount);
      }

      document.getElementById(amount).checked = true;

      console.log(this.selectedAmount);
    },
    numbersOnly: function () {
      $(".input-etopup").on("keypress", function (evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode < 48 || charCode > 57) {
          evt.preventDefault();
        } else {
          return true;
        }
      });
    },
    fixUserAmount: function (userAmount) {
      this.amountIsEligible = false;
      var max = this.maxTopUp;
      var am = userAmount.toString().substring(0, 2);
      var ar = am.split("");
      var amount = "";
      for (var i = 0; i < ar.length; ++i) {
        amount = amount.concat("", ar[i]);
      }
      var amountInt = parseInt(amount);
      if (amountInt > max) {
        amount = "" + max;
      } else if (amount.length == 0) {
        amount = "";
      }
      this.userAmount = amount;

      if (parseInt(this.userAmount) >= this.minTopUp) {
        this.amountIsEligible = true;
      }
      this.selectedAmount = this.userAmount;
      this.$store.commit("setAmount", this.selectedAmount);
    },
    choseMethod(paymentOption) {
      document.getElementById(paymentOption).checked = true;
      this.paymentOption = paymentOption;
      this.hasChoosenMethod = true;
      console.log(
        "hasChosenMethod : " +
        this.hasChoosenMethod +
        "amountIsEligible: " +
        this.amountIsEligible
      );
    },
    pay() {
      if (this.amountIsEligible && this.hasChoosenMethod) {
        var getCardsAndRecurringInfoResponse = sessionStorage.getItem(
          "getCardAndRecurringInfo_" + "F2G_" + this.token
        );
        var self = this;

        if (getCardsAndRecurringInfoResponse == null) {
          this.$store.commit("showLoader");

          axios({
            method: "post",
            url: "/epayments/getCardAndRecurringInfo",
            data: {
              applicationName: this.$store.state.applicationName,
              referrer: "localhost",
              type: this.getUserProfileAndTariffsObject.type,
              externalToken: this.token,
              msisdn: this.getUserProfileAndTariffsObject.msisdn,
              msisdnActivationDate: this.getUserProfileAndTariffsObject
                .activationDate
            }
          })
            .then(response => {
              console.log(
                "getCardAndRecurringInfo response: " +
                JSON.stringify(response.data)
              );

              if (response.data.result == "OK") {
                sessionStorage.setItem(
                  "getCardAndRecurringInfo_" + "F2G_" + self.token,
                  JSON.stringify(response.data)
                );
                this.$store.commit("setCardAndRecurringInfo", response.data);

                this.chooseFlowForPayment();
              } else {
                console.log("error in getCardAndRecurringInfo");
                this.$store.commit("hideLoader");
                this.$store.commit("showErrorComponent", true);
              }
            })
            .catch(error => {
              console.log(
                "getCardAndRecurringInfo responded with error: " + error
              );
              this.$store.commit("hideLoader");
              this.$store.commit("showErrorComponent", true);
            });
        } else {
          this.$store.commit(
            "setCardAndRecurringInfo",
            JSON.parse(getCardsAndRecurringInfoResponse)
          );
          this.chooseFlowForPayment();
        }
      }
    },
    chooseFlowForPayment() {
      if (
        (this.selectedAmount >= this.minTopUp &&
          this.selectedAmount <= this.maxTopUp) || this.getDataJumpFlow
      ) {
        if (document.getElementById("Credit").checked) {
          this.checkCardList();
        } else if (document.getElementById("Paypal").checked) {
          console.log("this.paypalPaymentStart()");
          this.paypalPaymentStart();
        } else {
          console.log("no choosen method is selected");
        }
      } else {
        console.log("the choosen amount is invalid");
      }
    },
    // Method to be called when user hasnt any card saved
    initiatePaymentNative: function () {
      //this.$store.commit('showLoader');
      var self = this;
      axios({
        method: "post",
        url: "/epayments/initiatePaymentNative",
        data: {
          applicationName: this.$store.state.applicationName,
          merchantRef: this.cardAndRecurringInfoObject.merchantRef,
          secToken: this.cardAndRecurringInfoObject.secToken,
          transactionCode: this.cardAndRecurringInfoObject.transactionCode,
          amount: this.selectedAmount,
          customerCode: this.$store.state.customerCode,
          customerName: this.$store.state.customerName,
          invoiceNumber: null,
          callbackURI: null,
          hostName: this.$store.state.hostName,
          locale: this.getLocale,
          msisdn: this.getUserProfileAndTariffsObject.msisdn,
          msisdnActivationDate: this.getUserProfileAndTariffsObject
            .activationDate,
          postalCode: null,
          sendCallback: "false",
          taxNumber: this.$store.state.taxNumber,
          transferMsisdn: this.getUserProfileAndTariffsObject.msisdn,
          twoStagesFlow: "false",
          currency: "EUR",
          userName: this.$store.state.guid,
          saveCard: "false",
          savedCard: null,
          useSavedCard: "false",
          minNumberOfInstalments: 0,
          maxNumberOfInstalments: 0,
          numberOfInstalments: 0,
          recurringType: "",
          recurringDate: "",
          recurringThreshold: "",
          recurringService: "",
          recurringAsset: "",
          requestInvoice: true,
          paymentMethod: "card",
          email: this.email,
          browser: this.determineBrowser(),
          screenWidth: window.screen.width,
          screenHeight: window.screen.height
        }
      })
        .then(response => {
          console.log("initiatePaymentNative " + JSON.stringify(response.data));
          if (response.data.result == "OK") {
            //clear service response from session storage

            sessionStorage.removeItem(
              "getUserProfileAndTariffs_" + "F2G_" + self.token
            );

            sessionStorage.removeItem(
              "getCardAndRecurringInfo_" + "F2G_" + self.token
            );
            ///sessionStorage.removeItem('getPaypalToken_' + "F2G_" + this.token);

            //Add a key to session storage to know if we have returned from bank
            sessionStorage.setItem(
              "activeFlow_" + "F2G_" + self.token,
              "false"
            );

            /* redirect to bank*/

            console.log("initiate payment done");
            if (this.getLocale == "el") {
              var lang = "gr";
            } else {
              lang = this.getLocale;
            }
            var paidAmount =
              response.data.paidAmount != undefined
                ? response.data.paidAmount
                : this.selectedAmount;

            //window.location.href = "/etopup/begin?merchantRef=" + this.getMerchantRefObject.merchantRef + "&secToken=" + this.getMerchantRefObject.secToken;

            //If datajumpflow is true create a cookie that will be used to check if we have used a datajump session
            if (this.getDataJumpFlow) {
              let expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + (3 * 24 * 60 * 60 * 1000)); // 3 days from now
              document.cookie = "dataJumpSession=true; expires=" + expiryDate.toUTCString() + "; path=/;";
            }

            window.location.href =
              "/" +
              lang +
              "/f2g/nbg-payments/?mid=" +
              response.data.merchantId +
              "&amount=" +
              paidAmount +
              "&sessionid=" +
              response.data.masterCardSessionId +
              "&applicationname=" +
              this.$store.state.applicationName +
              "&merchantref=" +
              this.cardAndRecurringInfoObject.merchantRef +
              "&sectoken=" +
              this.cardAndRecurringInfoObject.secToken +
              "&transactioncode=" +
              this.cardAndRecurringInfoObject.transactionCode +
              "&recurring=" +
              false +
              "&anonymous=" +
              false;
            this.$store.commit("hideLoader");
          } else {
            //Check if fraud fault
            if (response.data.fault.faultCode == 19) {
              var faultDescription = response.data.fault.faultDescription;
              this.$store.commit("hideLoader");
              console.log(faultDescription);
              this.$store.commit("showErrorComponent", true);
              this.$store.commit("setFaultDescription", faultDescription);
            } else {
              console.log(
                "initiatePaymentNative responded: " + response.data.result
              );
              this.$store.commit("hideLoader");
              this.$store.commit("showErrorComponent", true);
              console.log("initiate payment not done");
            }
          }
        })
        .catch(error => {
          this.$store.commit("hideLoader");
          this.$store.commit("showErrorComponent", true);
          console.log("initiatePaymentNative responded with error: " + error);
        });
    },
    checkCardList: function () {
      if (this.cardAndRecurringInfoObject.cardList.length == 0) {
        this.initiatePaymentNative();
        console.log("length == 0");
      } else if (this.cardAndRecurringInfoObject.cardList.length > 0) {
        this.$store.commit("hideLoader");
        this.$store.commit("showSavedCardComponent", true);
        console.log("length > 0");
      }
    },
    /**************************************************
     * ******************* PAYPAL *********************
     **************************************************/
    paypalPaymentStart() {
      //fault should be undefined in order to allow payment
      if (this.getUserProfileAndTariffsObject.fault == undefined) {
        this.getPaypalToken();
      } else {
        //inform user that it is not allow to procceed
        let faultDescription = this.getUserProfileAndTariffsObject.fault
          .faultDescription;
        this.$store.commit("showErrorComponent", true);
        this.$store.commit("setFaultDescription", faultDescription);
      }
    },
    getPaypalToken() {
      let self = this;

      /***********************************************
       * in case browser blocked popup window 
       * we store the response of get paypal token
       * in order to try again avoiding 
       * "Invalid Reload Duplicate Request id" error by calling
       * getPaypalToken for second time
       ***********************************************/
      if (this.getPaypalTokenResponse === '') {

        this.$store.commit("showLoader");

        axios({
          method: "post",
          url: "/paymentService/",
          params: {
            paymentService: "getPaypalToken",
            paymentDataObject: JSON.stringify(this.paymentInput())
          }
        })
          .then(response => {
            console.log("success token response: " + JSON.stringify(response));
            if (response.data.Status === 'SUCCESS') {

              self.getPaypalTokenResponse = response.data;

              let amount = self.selectedAmount; //if there is discount for employee this will change
              let originalAmount = self.selectedAmount;

              if (response.data.employeeAmount !== undefined) {
                amount = response.data.employeeAmount;
              }

              self.connectWithPaypal(
                response.data.token,
                response.data.PaymentID,
                amount,
                originalAmount
              );
            } else {
              this.$store.commit("showErrorComponent", true);
              this.$store.commit("hideLoader");
            }


          })
          .catch(error => {
            console.log("error token response: " + error);
            this.$store.commit("showErrorComponent", true);
            this.$store.commit("hideLoader");
          })
          .finally(() => {
            console.log("finally");
          });

      } else {
        let amount = self.selectedAmount; //if there is discount for employee this will change
        let originalAmount = self.selectedAmount;

        if (self.getPaypalTokenResponse.employeeAmount !== undefined) {
          amount = self.getPaypalTokenResponse.employeeAmount;
        }

        self.connectWithPaypal(
          self.getPaypalTokenResponse.token,
          self.getPaypalTokenResponse.PaymentID,
          amount,
          originalAmount
        );

      }
    },
    paymentInput: function () {
      let data = {
        amount: parseInt(this.selectedAmount),
        channel: "etopupF2G",
        msisdn: this.getUserProfileAndTariffsObject.msisdn,
        description: this.description(),
        transactionCode: this.cardAndRecurringInfoObject.transactionCode,
        requestInvoice: true //true or false (//always true on logged in users)
      };

      return data;
    },
    connectWithPaypal(token, paymentID, amount, originalAmount) {
      let self = this;
      console.log('connectWithPaypal')

      //var paypalButton = document.querySelector('.js-one-step-button-submit');
      let braintree = require('braintree');
      let client = require('braintree-web/client');
      let paypal = require('braintree-web/paypal');

      client.create({
        authorization: token
      }, function (clientErr, clientInstance) {
        if (clientErr) {
          console.error('paypal client.create error:', clientErr);
          self.$store.commit("showErrorComponent", true);
          return;
        }
        paypal.create({
          client: clientInstance
        }, function (paypalErr, paypalInstance) {
          if (paypalErr) {
            console.error('paypal paypal.create error:', paypalErr);
            self.$store.commit("showErrorComponent", true);
            return;
          }
          //paypalButton.removeAttribute('disabled');
          // When the button is clicked, attempt to tokenize.

          // Because tokenization opens a popup, this has to be called as a result of
          // customer action, like clicking a button. You cannot call this at any time.
          // So flow enters here on 3 sircumstances: when user selects Pay, Cancel or X button
          //console.log("payload: "+payload);
          paypalInstance.tokenize({
            flow: 'checkout',
            amount: amount, // Required
            currency: 'EUR' // Required

            // For more tokenization options, see the full PayPal tokenization documentation
            // http://braintree.github.io/braintree-web/current/PayPal.html#tokenize
          }, function (tokenizeErr, payload) {
            //print the payload with the information we get from paypal
            console.log("payload: " + JSON.stringify(payload));
            /**************************************************
             * check if an error has accured in PayPal payment
             * or if user selected cancel or X button
             ***************************************************/
            if (tokenizeErr) {
              /**********************************************
               * call updatePaymentStatus with status "CANCEL"
               * to informe backend that payment was canceled
               ************************************************/
              let data = {
                channel: "etopupF2G",
                paymentID: paymentID,
                token: token.substring(0, 20),
                userName: document.getElementById("user-info").getAttribute("data-username"),
                status: "CANCEL"
              };

              self.updatePaymentStatus(data);

              self.$store.commit("hideLoader");

              if (tokenizeErr.type !== 'CUSTOMER') {
                console.error('Error tokenizing:', tokenizeErr);
                //check of browser has blocked the paypal popup window
                if (tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED'
                  || tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED_IE'
                  || tokenizeErr.details.originalError.code == 'FRAME_SERVICE_FRAME_OPEN_FAILED_IE_BUG') {

                  //sessionStorage.setItem('blockedByPopUp_'+channel+"_"+commonFunctions.methods.getToken(), true);
                  // Your browser blocks the paypal popup window, please change your settings to unblock it
                  self.$store.commit("hideLoader");
                  //show message
                  $('#enable-pop-up-msg').show();
                  $('html, body').animate({
                    scrollTop: $("#enable-pop-up-msg").offset().top - 150
                  }, 1000);

                } else {
                  self.$store.commit('showErrorComponent', true);
                }
              } else {
                /**
                 * if user selectes cancel or X button
                 */
                if (tokenizeErr.code == "PAYPAL_POPUP_CLOSED") {
                  //because user have used the token he cant try again
                  //if user reload the page he can try again
                  self.$store.commit("setActiveFlow", false);
                  self.$store.commit('showErrorComponent', true);

                }

              }

            } else {
              //User paid successfully!!
              console.log('User paid successfully!! Got a nonce:' + payload.nonce);
              //I got payload with information for the paypal user that paid and i will submit 
              //them to the backend
              /*_sendDataToATG(
                payload, 
                callback, 
                _paymenttype, 
                _token.substring(0, 20), 
                channel);*/
              //the function that does the second call
              self.submitPaypalTransaction(
                payload,
                token.substring(0, 20),
                amount,
                originalAmount,
                paymentID
              )
            }
          });
        })

        /*paypalButton.addEventListener('click', paypalButtonClick, false);
        if($('.js-one-step-button-submit').attr("paypal")!="enabled"){
          console.log("js-one-step-button-submi click! ");
          $('.js-one-step-button-submit').trigger('click');
          $('.js-one-step-button-submit').attr("paypal","enabled");
        }*/



      })
    },
    updatePaymentStatus(data) {

      axios({
        method: "post",
        url: "/paymentService/",
        params: {
          paymentService: "UpdatePaymentStatus",
          paymentDataObject: JSON.stringify(data)
        }
      }).then(response => {
        console.log("success UpdatePaymentStatus: " + JSON.stringify(response));
      })
        .catch(error => {
          console.log("error UpdatePaymentStatus: " + error);
        })
        .finally(() => {
          console.log("UpdatePaymentStatus finally");
        });

    },
    submitPaypalTransaction(payload, token, amount, originalAmount, paymentID) {

      console.log('payload: ' + JSON.stringify(payload));

      let self = this;

      this.$store.commit("showLoader");

      let data = {
        paymentID: paymentID,
        amount: amount,
        originalAmount: originalAmount,
        paymentNonce: payload.nonce,
        firstName: payload.details.firstName,
        lastName: payload.details.lastName,
        email: payload.details.email,
        payerID: payload.details.payerId,
        username: this.loginInfo.username,
        locale: this.locale,
        channel: "etopupF2G",
        msisdn: this.loginInfo.msisdn,
        token: token,
        transactionCode: this.cardAndRecurringInfoObject.transactionCode,
        requestInvoice: "true", //always true on logged in users
        emailTopUp: this.loginInfo.email,
      }

      axios({
        method: "post",
        url: "/paymentService/",
        params: {
          paymentService: "SubmitPaypalTransaction",
          paymentDataObject: JSON.stringify(data)
        }
      }).then(response => {
        console.log("success SubmitPaypalTransaction: " + JSON.stringify(response));
        if (response.data.Status == "SUCCESS") {
          //redirect to success page
          window.location.href =
            window.location.href
            + '/?merchantRef=' + paymentID
            + '&status=OK'
            + '&msisdn=' + self.loginInfo.msisdn
            + '&amount=' + originalAmount
            + '&transactionCode=' + self.cardAndRecurringInfoObject.transactionCode;
        } else {
          //error smt went
          //show overlay
          this.$store.commit("showErrorComponent", true);
        }

      })
        .catch(error => {
          console.log("error UpdatePaymentStatus: " + error);
          this.$store.commit("showErrorComponent", true);
        })
        .finally(() => {
          console.log("UpdatePaymentStatus finally");
          this.$store.commit("hideLoader");
        });


    },
    /*
     * Constructs the description for the Paypal Payment
     */
    description() {
      let d = new Date();
      let timeMilis = d.getTime();
      let dateSTR = this.dateFormatDMYslashes_HM_S(timeMilis);
      let message =
        "TS:" +
        this.getUserProfileAndTariffsObject.msisdn +
        ", AMT:" +
        this.selectedAmount +
        ", REF:PAYMENT_ID, Date:" +
        dateSTR;

      return message;
    },
    dateFormatDMYslashes_HM_S(stringDate) {
      //uses dots
      var date = new Date(stringDate); //takes as a param the date in string format
      var returnDate =
        this.addZero(date.getDate()) +
        "/" +
        (date.getMonth() + 1) +
        "/" +
        date.getFullYear() +
        " " +
        this.addZero(date.getHours()) +
        ":" +
        this.addZero(date.getMinutes()) +
        ":" +
        this.addZero(date.getSeconds()); //cuts the information needed from date
      return returnDate;
    },
    addZero(i) {
      //add a "0" if hour or minute is one digit i.e: 9 -> 09
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    determineBrowser() {
      var nAgt = navigator.userAgent ? navigator.userAgent : "";
      var browserName = navigator.appName ? navigator.appName : "";
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Opera, the true version might also be after "OPR" or after "Version"
      else if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In MSIE 11, the true version is rv "Trident" in userAgent
      else if ((verOffset = nAgt.indexOf("Trident/7.0")) != -1) {
        browserName = "Internet Explorer";
        fullVersion = "11.0";
      }
      //start of handling all Edge cases
      else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("EdgA")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("EdgiOS")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt('' + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }


      return browserName + ' ' + fullVersion;
    }
  }
};
</script>

<style scoped>
.banner-colorful .container-button-banner{
    margin-left: 0;
}
.btn-banner-logwin{
    display: flex;
    /* justify-content: center; */
    flex:1;
    justify-content: flex-end;
}
.tooltip{
    margin-right: 15px;
}
.titles-container{
  flex: 4;
  margin-left: 15px;
}
@media screen and (max-width: 992px) {
    .btn-banner-logwin{
        flex-direction: column;
    }
    .tooltip .tooltiptext {
        max-width: 180px;
        right: 0;
    }
    .tooltip{
        align-self: center;
        margin-right: 0px;
    }
}
.learn-more{
    color: blue;
    margin-left: 5px;
    text-decoration: underline;
}
</style>